export default __webpack_public_path__ + "c79087b.png";